/* eslint-disable */
/* eslint-disable @next/next/no-img-element */
import { useRouter } from "next/router";
import React from "react";
import { decode as base64_decode } from "base-64";
import Image from "next/future/image";

function List({ data, dataHeader = {}, language }) {
  const router = useRouter();
  const pathname = router.asPath.split("/").pop();

  const handleClick = (url) => {
    if (url !== "#")
      window.open(
        url,
        // "https://wa.me/0831?text=oke",
        "_blank",
        "noopener,noreferrer"
      );
  };

  return (
    <>
      {/* <img
        src={language === "EN" ? data?.en_featured_img : data?.id_featured_img}
        alt={
          language === "EN"
            ? data?.en_alt_featured_img
            : data?.id_alt_featured_img
        }
      /> */}
      <div style={{ width: "100%" }}>
        <Image
          className="image-blogs-detail"
          src={
            language === "EN" ? data?.en_featured_img : data?.id_featured_img
          }
          alt={
            language === "EN"
              ? data?.en_alt_featured_img
              : data?.id_alt_featured_img
          }
          width={730}
          height={350}
          //objectFit="contain" // Scale your image down to fit into the container
        />
      </div>

      <h1
        style={{ marginTop: "36px", marginBottom: "25px" }}
        className="mb-5"
        dangerouslySetInnerHTML={{
          __html: language === "EN" ? data?.en_title : data?.id_title,
        }}
      ></h1>

      <p>
        Posted On{" "}
        <span
          dangerouslySetInnerHTML={{
            __html: data?.publishedAt,
          }}
        ></span>
      </p>

      {language === "EN" && data?.en_content && (
        <div
          style={{ marginTop: "5px", marginBottom: "30px" }}
          dangerouslySetInnerHTML={{
            __html: decodeURIComponent(escape(base64_decode(data.en_content))),
          }}
        ></div>
      )}

      {language === "ID" && data?.id_content && (
        <div
          style={{ marginTop: "5px", marginBottom: "30px" }}
          dangerouslySetInnerHTML={{
            __html: decodeURIComponent(escape(base64_decode(data.id_content))),
          }}
        ></div>
      )}
      <div className="col-btn-talk col-btn-talk-blog">
        <button
          className="btn-talk btn-cta-detail"
          style={{ backgroundColor: dataHeader?.headerCTA?.bg_color }}
          onClick={() => handleClick(dataHeader?.headerCTA?.url)}
          type="button"
        >
          <Image
            width={20}
            height={20}
            src={dataHeader?.headerCTA?.icon}
            alt={dataHeader?.headerCTA?.alt_icon}
          />
          {/* <img
            src={dataHeader?.headerCTA?.icon}
            alt={dataHeader?.headerCTA?.alt_icon}
          /> */}
          <span
            dangerouslySetInnerHTML={{
              __html:
                language === "EN"
                  ? dataHeader?.headerCTA?.en_name
                  : dataHeader?.headerCTA?.id_name,
            }}
          ></span>
        </button>
      </div>
      <p style={{ marginBottom: "30px" }}>
        <strong>
          Tags:{" "}
          <span
            dangerouslySetInnerHTML={{
              __html: data?.tag,
            }}
          ></span>
        </strong>
      </p>
    </>
  );
}

export default List;
